import styled from "styled-components";

export const MapContainer = styled.div`
    height: 100%;
    width: 100%;
    position: relative;
`;

export const InfoButton = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const InfoIcon = styled.div`
    font-size: 16px;
    color: #000;
`;

export const MapWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const MapDiv = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

export const NoCourierMessage = styled.div`
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(255, 255, 255, 0.9);
    padding: 10px 20px;
    border-radius: 8px;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const NoCourierText = styled.p`
    margin: 0;
    color: #666;
    font-size: 14px;
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: #f5f5f5;
    border-radius: 4px;
`;

export const LoadingText = styled.p`
    margin: 0;
    color: #666;
`;

export const ExternalPopup = styled.div`
    position: absolute;
    left: ${props => props.x + 20}px;
    top: ${props => props.y - 100}px;
    z-index: 10000;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 280px;
    max-width: 320px;
    border: 1px solid #ddd;
`;

export const PopupContent = styled.div`
    position: relative;
    padding: 12px;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 8px;
    right: 8px;
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #666;

    &:hover {
        color: #000;
    }
`;
